import { IFactorConfiguration, FactorConfigurationService } from '@aston/foundation';
import { switchMap, catchError } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';

import * as AppStoreSelectors from '../../root-store/app-store/selectors';
import { AppConstants } from '../../app.constants';

@Injectable({
	providedIn: 'root'
})
export class ConsoleFactorConfigurationService extends FactorConfigurationService {

	private http = inject(HttpClient)
	private store = inject(Store)

	loadFactorConfig(): Observable<void> {
		return EMPTY;
	}

	getFactorConfig(): Observable<IFactorConfiguration> {
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get<IFactorConfiguration>(`${config.apiUrl}/api/Configuration`)),
			catchError(_ => of(AppConstants.DEFAULT_FACTOR_CONFIGURATION))
		);
	}
}
